var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "calculate-price__form-section" },
      [
        _c("h2", { staticClass: "calculate-price__form-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.leave_area
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.rooms, function(room, index) {
          return _c("div", { key: index, staticClass: "mb-10" }, [
            _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.facilityTypes &&
                      _vm.facilityTypes[room] &&
                      _vm.facilityTypes[room]["value"]
                  ) +
                  "\n        "
              ),
              room == "other"
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.rooms
                      )
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "hidden",
                name: "leaveArea[" + room + "][name_nl]"
              },
              domProps: {
                value:
                  (_vm.facilityTypes[room] &&
                    _vm.facilityTypes[room]["value_lang"]["nl"]) +
                  (room == "other"
                    ? _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.rooms
                    : "")
              }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "hidden",
                name: "leaveArea[" + room + "][name_en]"
              },
              domProps: {
                value:
                  (_vm.facilityTypes[room] &&
                    _vm.facilityTypes[room]["value_lang"]["en"]) +
                  (room == "other"
                    ? _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.rooms
                    : "")
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5" },
              [
                _c(
                  "div",
                  [
                    _c("theme-numeric", {
                      attrs: {
                        "valid-scope": "modal-form",
                        name: "leaveArea[" + room + "][width]",
                        label: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.calculateSurface(
                            _vm.leaveArea,
                            room,
                            "leaveArea"
                          )
                        }
                      },
                      model: {
                        value: _vm.leaveArea[room].width,
                        callback: function($$v) {
                          _vm.$set(_vm.leaveArea[room], "width", $$v)
                        },
                        expression: "leaveArea[room].width"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("theme-numeric", {
                      attrs: {
                        "valid-scope": "modal-form",
                        name: "leaveArea[" + room + "][length]",
                        label: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.calculateSurface(
                            _vm.leaveArea,
                            room,
                            "leaveArea"
                          )
                        }
                      },
                      model: {
                        value: _vm.leaveArea[room].length,
                        callback: function($$v) {
                          _vm.$set(_vm.leaveArea[room], "length", $$v)
                        },
                        expression: "leaveArea[room].length"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "theme-numeric",
                      {
                        attrs: {
                          "valid-scope": "modal-form",
                          name: "leaveArea[" + room + "][surface]",
                          label: "",
                          IsExtraInfo: true
                        },
                        on: {
                          input: function($event) {
                            return _vm.countLeaveAreaPoints(_vm.leaveArea)
                          }
                        },
                        model: {
                          value: _vm.leaveArea[room].surface,
                          callback: function($$v) {
                            _vm.$set(_vm.leaveArea[room], "surface", $$v)
                          },
                          expression: "leaveArea[room].surface"
                        }
                      },
                      [
                        _c("template", { slot: "extra-info" }, [
                          _vm._v(" m"),
                          _c("sup", [_vm._v("2")])
                        ])
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            )
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c("input", {
              attrs: {
                type: "hidden",
                name: "leaveArea[include_shower]",
                value: "0"
              }
            }),
            _vm._v(" "),
            _c("theme-checkboxes", {
              attrs: {
                id: "includeShower",
                label: "",
                "is-single-checkbox": true,
                name: "leaveArea[include_shower]",
                options: {
                  "1":
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.toilet_in_shower_or_bathroom) +
                    " " +
                    (_vm.leaveArea.include_shower == 1 ? "-1" : "")
                }
              },
              on: {
                input: function($event) {
                  return _vm.countLeaveAreaPoints(_vm.leaveArea)
                }
              },
              model: {
                value: _vm.leaveArea.include_shower,
                callback: function($$v) {
                  _vm.$set(_vm.leaveArea, "include_shower", $$v)
                },
                expression: "leaveArea.include_shower"
              }
            }),
            _vm._v(" "),
            _vm.leaveArea.include_shower == 1
              ? [
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "leaveArea[include_shower]",
                      value: "1"
                    }
                  })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "leaveArea[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.leave_area
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.leaveArea.total,
                  callback: function($$v) {
                    _vm.$set(_vm.leaveArea, "total", $$v)
                  },
                  expression: "leaveArea.total"
                }
              })
            ],
            1
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calculate-price__form-section" },
      [
        _c("h2", { staticClass: "calculate-price__form-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.other_spaces
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _vm._l(_vm.otherRooms, function(room, index) {
          return _c("div", { key: index, staticClass: "mb-10" }, [
            _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
              room == "other"
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.other_spaces
                      )
                    )
                  ])
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.facilityTypes &&
                          _vm.facilityTypes[room] &&
                          _vm.facilityTypes[room]["value"]
                      )
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "hidden",
                name: "otherSpaces[" + room + "][name_nl]"
              },
              domProps: {
                value:
                  (_vm.facilityTypes[room] &&
                    _vm.facilityTypes[room]["value_lang"]["nl"]) +
                  (room == "other"
                    ? _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.rooms
                    : "")
              }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                type: "hidden",
                name: "otherSpaces[" + room + "][name_en]"
              },
              domProps: {
                value:
                  (_vm.facilityTypes[room] &&
                    _vm.facilityTypes[room]["value_lang"]["en"]) +
                  (room == "other"
                    ? _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.rooms
                    : "")
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5" },
              [
                _c(
                  "div",
                  [
                    _c("theme-numeric", {
                      attrs: {
                        "valid-scope": "modal-form",
                        name: "otherSpaces[" + room + "][width]",
                        label: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.calculateSurface(
                            _vm.otherSpaces,
                            room,
                            "otherSpaces"
                          )
                        }
                      },
                      model: {
                        value: _vm.otherSpaces[room].width,
                        callback: function($$v) {
                          _vm.$set(_vm.otherSpaces[room], "width", $$v)
                        },
                        expression: "otherSpaces[room].width"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("theme-numeric", {
                      attrs: {
                        "valid-scope": "modal-form",
                        name: "otherSpaces[" + room + "][length]",
                        label: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.calculateSurface(
                            _vm.otherSpaces,
                            room,
                            "otherSpaces"
                          )
                        }
                      },
                      model: {
                        value: _vm.otherSpaces[room].length,
                        callback: function($$v) {
                          _vm.$set(_vm.otherSpaces[room], "length", $$v)
                        },
                        expression: "otherSpaces[room].length"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "theme-numeric",
                      {
                        attrs: {
                          "valid-scope": "modal-form",
                          name: "otherSpaces[" + room + "][surface]",
                          label: "",
                          IsExtraInfo: true
                        },
                        on: {
                          input: function($event) {
                            return _vm.countOtherSpacesPoints(_vm.otherSpaces)
                          }
                        },
                        model: {
                          value: _vm.otherSpaces[room].surface,
                          callback: function($$v) {
                            _vm.$set(_vm.otherSpaces[room], "surface", $$v)
                          },
                          expression: "otherSpaces[room].surface"
                        }
                      },
                      [
                        _c("template", { slot: "extra-info" }, [
                          _vm._v(" m"),
                          _c("sup", [_vm._v("2")])
                        ])
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            )
          ])
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mb-10" },
          [
            _c("input", {
              attrs: {
                type: "hidden",
                name: "otherSpaces[attic_no_staircase]",
                value: "0"
              }
            }),
            _vm._v(" "),
            _c("theme-checkboxes", {
              attrs: {
                id: "attic_no_staircase",
                label: "",
                "is-single-checkbox": true,
                name: "otherSpaces[attic_no_staircase]",
                options: {
                  "1":
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.attic_no_staircase) +
                    " " +
                    (_vm.otherSpaces.attic_no_staircase == 1 ? "-5" : "")
                }
              },
              on: {
                input: function($event) {
                  return _vm.countOtherSpacesPoints(_vm.otherSpaces)
                }
              },
              model: {
                value: _vm.otherSpaces.attic_no_staircase,
                callback: function($$v) {
                  _vm.$set(_vm.otherSpaces, "attic_no_staircase", $$v)
                },
                expression: "otherSpaces.attic_no_staircase"
              }
            }),
            _vm._v(" "),
            _vm.otherSpaces.attic_no_staircase == 1
              ? [
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "otherSpaces[attic_no_staircase]",
                      value: "1"
                    }
                  })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "otherSpaces[total]",
                  label: _vm.totalLabel(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.other_spaces
                  ),
                  isReadonly: true
                },
                model: {
                  value: _vm.otherSpaces.total,
                  callback: function($$v) {
                    _vm.$set(_vm.otherSpaces, "total", $$v)
                  },
                  expression: "otherSpaces.total"
                }
              })
            ],
            1
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.heating
            ) +
            "\n      (" +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.central_heating
            ) +
            ")\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_heated_rooms),
                  name: "heating[heated_rooms]"
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.heated_rooms,
                  callback: function($$v) {
                    _vm.$set(_vm.heating, "heated_rooms", $$v)
                  },
                  expression: "heating.heated_rooms"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_cooled_rooms),
                  name: "heating[cooled_rooms]"
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.cooled_rooms,
                  callback: function($$v) {
                    _vm.$set(_vm.heating, "cooled_rooms", $$v)
                  },
                  expression: "heating.cooled_rooms"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties
                        .number_of_other_rooms_with_heating),
                  name: "heating[other_rooms_with_heating]"
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.other_rooms_with_heating,
                  callback: function($$v) {
                    _vm.$set(_vm.heating, "other_rooms_with_heating", $$v)
                  },
                  expression: "heating.other_rooms_with_heating"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_other_cooled_rooms),
                  name: "heating[other_rooms_with_cooling]"
                },
                on: { input: _vm.countHeatingPoints },
                model: {
                  value: _vm.heating.other_rooms_with_cooling,
                  callback: function($$v) {
                    _vm.$set(_vm.heating, "other_rooms_with_cooling", $$v)
                  },
                  expression: "heating.other_rooms_with_cooling"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "heating[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_heating,
                isReadonly: true
              },
              model: {
                value: _vm.heating.total,
                callback: function($$v) {
                  _vm.$set(_vm.heating, "total", $$v)
                },
                expression: "heating.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.energy_performance
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.property_type
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              columnDirection: true,
              name: "energy[property_type]",
              options: {
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.single_family_home,
                "2":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.multi_family_home
              }
            },
            on: { input: _vm.countEnergyPoints },
            model: {
              value: _vm.energy.property_type,
              callback: function($$v) {
                _vm.$set(_vm.energy, "property_type", $$v)
              },
              expression: "energy.property_type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.energy.energy_performance_fee != 1
        ? _c("div", { staticClass: "mb-10" }, [
            _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.energy_label
                  ) +
                  "\n        "
              ),
              _vm.energy.energy_label &&
              _vm.energyLabels[_vm.energy.energy_label] &&
              _vm.energyLabels[_vm.energy.energy_label]["slug"] !=
                "no_label_or_index"
                ? _c("strong", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.energy.energy_points || "") +
                        "\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-10" },
              [
                _c("theme-radios", {
                  attrs: {
                    name: "energy[energy_label]",
                    options: _vm.energyLabelsOptions,
                    sort: true,
                    "sort-by": "custom",
                    "custom-order": _vm.energyLabelsCustomOrder
                  },
                  on: { input: _vm.countEnergyPoints },
                  model: {
                    value: _vm.energy.energy_label,
                    callback: function($$v) {
                      _vm.$set(_vm.energy, "energy_label", $$v)
                    },
                    expression: "energy.energy_label"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.energy.energy_label &&
            _vm.energyLabels[_vm.energy.energy_label] &&
            _vm.energyLabels[_vm.energy.energy_label]["slug"] ==
              "no_label_or_index"
              ? _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-12" }, [
                  _c(
                    "div",
                    { staticClass: "col-span-4" },
                    [
                      _c("theme-input", {
                        attrs: {
                          label:
                            (_vm.locales &&
                              _vm.locales.properties &&
                              _vm.locales.properties.construction_year) +
                            " " +
                            ((_vm.energy.building_construction_year &&
                              _vm.energy.energy_points) ||
                              ""),
                          name: "energy[building_construction_year]"
                        },
                        on: { input: _vm.countEnergyPoints },
                        model: {
                          value: _vm.energy.building_construction_year,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.energy,
                              "building_construction_year",
                              $$v
                            )
                          },
                          expression: "energy.building_construction_year"
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-5" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "energy[energy_performance_fee]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "energy_performance_fee",
              label: "",
              "is-single-checkbox": true,
              name: "energy[energy_performance_fee]",
              options: {
                "1":
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.energy_performance_fee) +
                  " " +
                  (_vm.energy.energy_performance_fee == 1
                    ? _vm.energy.energy_points
                    : "")
              }
            },
            on: { input: _vm.countEnergyPoints },
            model: {
              value: _vm.energy.energy_performance_fee,
              callback: function($$v) {
                _vm.$set(_vm.energy, "energy_performance_fee", $$v)
              },
              expression: "energy.energy_performance_fee"
            }
          }),
          _vm._v(" "),
          _vm.energy.energy_performance_fee == 1
            ? [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "energy[energy_performance_fee]",
                    value: "1"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-5" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "monument_allowance[value]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "monumentAllowance",
              label: "",
              "is-single-checkbox": true,
              name: "monument_allowance[value]",
              options: {
                "1":
                  "" +
                  (_vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.monument_allowance_energy)
              }
            },
            on: { input: _vm.countEnergyPoints },
            model: {
              value: _vm.monumentAllowance.value,
              callback: function($$v) {
                _vm.$set(_vm.monumentAllowance, "value", $$v)
              },
              expression: "monumentAllowance.value"
            }
          }),
          _vm._v(" "),
          _vm.monumentAllowance.value == 1
            ? [
                _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "monument_allowance[value]",
                    value: "1"
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "energy[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_energy,
                precision: 0,
                isReadonly: true
              },
              model: {
                value: _vm.energy.total,
                callback: function($$v) {
                  _vm.$set(_vm.energy, "total", $$v)
                },
                expression: "energy.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.kitchen
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.worktop_length
                    ) +
                    "\n          "
                ),
                _vm.kitchen.worktop_length.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchen.worktop_length.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[worktop_length]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.less_than_1_meter,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties["1_2_meters"],
                    "3":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.more_than_2_meters
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.worktop_length.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.worktop_length, "value", $$v)
                  },
                  expression: "kitchen.worktop_length.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.cooker
                    ) +
                    "\n          "
                ),
                _vm.kitchen.cooker.value
                  ? _c("strong", [
                      _vm._v(_vm._s(_vm.kitchen.cooker.total || ""))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[cooker]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_gas_hob,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_ceramic_hob,
                    "3":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_induction_hob
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.cooker.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.cooker, "value", $$v)
                  },
                  expression: "kitchen.cooker.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.oven
                    ) +
                    "\n          "
                ),
                _vm.kitchen.oven.value
                  ? _c("strong", [_vm._v(_vm._s(_vm.kitchen.oven.total || ""))])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  columnDirection: true,
                  name: "kitchen[oven]",
                  options: {
                    "1":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_gas_oven,
                    "2":
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.built_in_electric_oven
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.oven.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.oven, "value", $$v)
                  },
                  expression: "kitchen.oven.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mb-10" }, [
        _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-5 gap-5" }, [
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_microwave]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_microwave",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_microwave]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_microwave) +
                      " " +
                      (_vm.kitchen.built_in_microwave.value == 1
                        ? _vm.kitchen.built_in_microwave.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_microwave.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_microwave, "value", $$v)
                  },
                  expression: "kitchen.built_in_microwave.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_extractor_hood]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_extractor_hood",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_extractor_hood]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_extractor_hood) +
                      " " +
                      (_vm.kitchen.built_in_extractor_hood.value == 1
                        ? _vm.kitchen.built_in_extractor_hood.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_extractor_hood.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_extractor_hood, "value", $$v)
                  },
                  expression: "kitchen.built_in_extractor_hood.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_fridge]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_fridge",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_fridge]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_fridge) +
                      " " +
                      (_vm.kitchen.built_in_fridge.value == 1
                        ? _vm.kitchen.built_in_fridge.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_fridge.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_fridge, "value", $$v)
                  },
                  expression: "kitchen.built_in_fridge.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_freezer]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_freezer",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_freezer]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_freezer) +
                      " " +
                      (_vm.kitchen.built_in_freezer.value == 1
                        ? _vm.kitchen.built_in_freezer.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_freezer.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_freezer, "value", $$v)
                  },
                  expression: "kitchen.built_in_freezer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "kitchen[built_in_dishwasher]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "built_in_dishwasher",
                  label: "",
                  "is-single-checkbox": true,
                  name: "kitchen[built_in_dishwasher]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.built_in_dishwasher) +
                      " " +
                      (_vm.kitchen.built_in_dishwasher.value == 1
                        ? _vm.kitchen.built_in_dishwasher.total
                        : "")
                  }
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.built_in_dishwasher.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.built_in_dishwasher, "value", $$v)
                  },
                  expression: "kitchen.built_in_dishwasher.value"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[luxury_mixer_tap]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.luxury_mixer_tap) +
                    " " +
                    (_vm.kitchen.luxury_mixer_tap.value
                      ? _vm.kitchen.luxury_mixer_tap.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.luxury_mixer_tap.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.luxury_mixer_tap, "value", $$v)
                  },
                  expression: "kitchen.luxury_mixer_tap.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[thermostatic_water_mixer]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.thermostatic_water_mixer) +
                    " " +
                    (_vm.kitchen.thermostatic_water_mixer.value
                      ? _vm.kitchen.thermostatic_water_mixer.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.thermostatic_water_mixer.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.thermostatic_water_mixer, "value", $$v)
                  },
                  expression: "kitchen.thermostatic_water_mixer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "kitchen[extra_single_cupboard]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.extra_single_cupboard) +
                    " " +
                    (_vm.kitchen.extra_single_cupboard.value
                      ? _vm.kitchen.extra_single_cupboard.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countKitchenPoints },
                model: {
                  value: _vm.kitchen.extra_single_cupboard.value,
                  callback: function($$v) {
                    _vm.$set(_vm.kitchen.extra_single_cupboard, "value", $$v)
                  },
                  expression: "kitchen.extra_single_cupboard.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "kitchen[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_kitchen,
                precision: 2,
                isReadonly: true
              },
              model: {
                value: _vm.kitchen.total,
                callback: function($$v) {
                  _vm.$set(_vm.kitchen, "total", $$v)
                },
                expression: "kitchen.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.sanitary
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_toilets) +
                    " " +
                    ((_vm.sanitary.number_of_toilets.value &&
                      _vm.sanitary.number_of_toilets.total) ||
                      ""),
                  name: "sanitary[number_of_toilets]"
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.number_of_toilets.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.number_of_toilets, "value", $$v)
                  },
                  expression: "sanitary.number_of_toilets.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.sanitary.number_of_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_hunged_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_hunged_toilets.value &&
                          _vm.sanitary.number_of_hunged_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_hunged_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_hunged_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_hunged_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_hunged_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sanitary.number_of_toilets.value > 0
            ? _c(
                "div",
                [
                  _c("theme-input", {
                    attrs: {
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_separate_toilets) +
                        " " +
                        ((_vm.sanitary.number_of_separate_toilets.value &&
                          _vm.sanitary.number_of_separate_toilets.total) ||
                          ""),
                      name: "sanitary[number_of_separate_toilets]"
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_separate_toilets.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_separate_toilets,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_separate_toilets.value"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-input", {
                attrs: {
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.number_of_washbasins) +
                    " " +
                    ((_vm.sanitary.number_of_washbasins.value &&
                      _vm.sanitary.number_of_washbasins.total) ||
                      ""),
                  name: "sanitary[number_of_washbasins]"
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.number_of_washbasins.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.number_of_washbasins, "value", $$v)
                  },
                  expression: "sanitary.number_of_washbasins.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.sanitary
                ) +
                "\n        "
            ),
            _vm.sanitary.shower_bath.value
              ? _c("strong", [
                  _vm._v(_vm._s(_vm.sanitary.shower_bath.total || ""))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              label: "",
              name: "sanitary[shower_bath]",
              options: {
                "0":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.no_shower_or_bath,
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.shower_available,
                "2":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.bath_available,
                "3":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.separate_bath_and_shower_in_one_room
              }
            },
            on: { input: _vm.countSanitaryPoints },
            model: {
              value: _vm.sanitary.shower_bath.value,
              callback: function($$v) {
                _vm.$set(_vm.sanitary.shower_bath, "value", $$v)
              },
              expression: "sanitary.shower_bath.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[cupboard_with_built_in_washbasin]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "cupboard_with_built_in_washbasin",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[cupboard_with_built_in_washbasin]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties
                          .cupboard_with_built_in_washbasin) +
                      " " +
                      (_vm.sanitary.cupboard_with_built_in_washbasin.value == 1
                        ? _vm.sanitary.cupboard_with_built_in_washbasin.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.cupboard_with_built_in_washbasin.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.cupboard_with_built_in_washbasin,
                      "value",
                      $$v
                    )
                  },
                  expression: "sanitary.cupboard_with_built_in_washbasin.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[extra_for_a_bubble_bath]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "extra_for_a_bubble_bath",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[extra_for_a_bubble_bath]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.extra_for_a_bubble_bath) +
                      " " +
                      (_vm.sanitary.extra_for_a_bubble_bath.value == 1
                        ? _vm.sanitary.extra_for_a_bubble_bath.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.extra_for_a_bubble_bath.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.extra_for_a_bubble_bath, "value", $$v)
                  },
                  expression: "sanitary.extra_for_a_bubble_bath.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[mounted_complete_separation_of_shower]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "mounted_complete_separation_of_shower",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[mounted_complete_separation_of_shower]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties
                          .mounted_complete_separation_of_shower) +
                      " " +
                      (_vm.sanitary.mounted_complete_separation_of_shower
                        .value == 1
                        ? _vm.sanitary.mounted_complete_separation_of_shower
                            .total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value:
                    _vm.sanitary.mounted_complete_separation_of_shower.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.mounted_complete_separation_of_shower,
                      "value",
                      $$v
                    )
                  },
                  expression:
                    "sanitary.mounted_complete_separation_of_shower.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[towel_radiator]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "towel_radiator",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[towel_radiator]",
                  options: {
                    "1":
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.towel_radiator) +
                      " " +
                      (_vm.sanitary.towel_radiator.value == 1
                        ? _vm.sanitary.towel_radiator.total
                        : "")
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.towel_radiator.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.towel_radiator, "value", $$v)
                  },
                  expression: "sanitary.towel_radiator.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("input", {
                attrs: {
                  type: "hidden",
                  name: "sanitary[power_outlet]",
                  value: "0"
                }
              }),
              _vm._v(" "),
              _c("theme-checkboxes", {
                attrs: {
                  id: "power_outlet",
                  label: "",
                  "is-single-checkbox": true,
                  name: "sanitary[power_outlet]",
                  options: {
                    "1":
                      "" +
                      (_vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.power_outlet)
                  }
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.power_outlet.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.power_outlet, "value", $$v)
                  },
                  expression: "sanitary.power_outlet.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "sanitary[luxury_mixer_tap]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.luxury_mixer_tap) +
                    " " +
                    (_vm.sanitary.luxury_mixer_tap.value
                      ? _vm.sanitary.luxury_mixer_tap.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.luxury_mixer_tap.value,
                  callback: function($$v) {
                    _vm.$set(_vm.sanitary.luxury_mixer_tap, "value", $$v)
                  },
                  expression: "sanitary.luxury_mixer_tap.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "sanitary[thermostatic_water_mixer]",
                  label:
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.thermostatic_water_mixer) +
                    " " +
                    (_vm.sanitary.thermostatic_water_mixer.value
                      ? _vm.sanitary.thermostatic_water_mixer.total
                      : ""),
                  precision: 0
                },
                on: { input: _vm.countSanitaryPoints },
                model: {
                  value: _vm.sanitary.thermostatic_water_mixer.value,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.sanitary.thermostatic_water_mixer,
                      "value",
                      $$v
                    )
                  },
                  expression: "sanitary.thermostatic_water_mixer.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.sanitary.power_outlet.value > 0
            ? _c(
                "div",
                [
                  _c("theme-numeric", {
                    attrs: {
                      "valid-scope": "modal-form",
                      name: "sanitary[number_of_power_outlet]",
                      label:
                        (_vm.locales &&
                          _vm.locales.properties &&
                          _vm.locales.properties.number_of_power_outlet) +
                        " " +
                        (_vm.sanitary.number_of_power_outlet.value
                          ? _vm.sanitary.power_outlet.total
                          : ""),
                      precision: 0
                    },
                    on: { input: _vm.countSanitaryPoints },
                    model: {
                      value: _vm.sanitary.number_of_power_outlet.value,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.sanitary.number_of_power_outlet,
                          "value",
                          $$v
                        )
                      },
                      expression: "sanitary.number_of_power_outlet.value"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "sanitary[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_sanitary,
                precision: 2,
                isReadonly: true
              },
              model: {
                value: _vm.sanitary.total,
                callback: function($$v) {
                  _vm.$set(_vm.sanitary, "total", $$v)
                },
                expression: "sanitary.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.housing_for_disabled
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "grid grid-cols-1 lg:grid-cols-4 gap-5 mb-10 items-end"
        },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "disabled[total_investment]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.disabled_total_investment,
                  precision: 2
                },
                on: { input: _vm.countDisabledPoints },
                model: {
                  value: _vm.disabled.total_investment.value,
                  callback: function($$v) {
                    _vm.$set(_vm.disabled.total_investment, "value", $$v)
                  },
                  expression: "disabled.total_investment.value"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "disabled[subsidy]",
                  label:
                    _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.disabled_investment_subsidy,
                  precision: 2
                },
                on: { input: _vm.countDisabledPoints },
                model: {
                  value: _vm.disabled.disabled_subsidy.value,
                  callback: function($$v) {
                    _vm.$set(_vm.disabled.disabled_subsidy, "value", $$v)
                  },
                  expression: "disabled.disabled_subsidy.value"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "disabled[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_housing_for_disabled,
                isReadonly: true
              },
              model: {
                value: _vm.disabled.total,
                callback: function($$v) {
                  _vm.$set(_vm.disabled, "total", $$v)
                },
                expression: "disabled.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.shared_parking
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.shared_parking
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("theme-radios", {
            attrs: {
              name: "shared_parking[type]",
              options: _vm.sharedParkingOptions
            },
            on: { input: _vm.countSharedParkingPoints },
            model: {
              value: _vm.sharedParking.type,
              callback: function($$v) {
                _vm.$set(_vm.sharedParking, "type", $$v)
              },
              expression: "sharedParking.type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-4 mb-10" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "shared_parking[number_of_addresses]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.number_of_addresses
              },
              on: { input: _vm.countSharedParkingPoints },
              model: {
                value: _vm.sharedParking.number_of_addresses,
                callback: function($$v) {
                  _vm.$set(_vm.sharedParking, "number_of_addresses", $$v)
                },
                expression: "sharedParking.number_of_addresses"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "shared_parking[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_shared_parking,
                isReadonly: true
              },
              model: {
                value: _vm.sharedParking.total,
                callback: function($$v) {
                  _vm.$set(_vm.sharedParking, "total", $$v)
                },
                expression: "sharedParking.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.private_outdoor_space
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10" },
        [
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[space_area]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.private_outdoor_space),
                  precision: 2
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoorSpacesArea,
                  callback: function($$v) {
                    _vm.outdoorSpacesArea = $$v
                  },
                  expression: "outdoorSpacesArea"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_space_area]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_outdoor_space),
                  precision: 2
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoorCommonSpacesArea,
                  callback: function($$v) {
                    _vm.outdoorCommonSpacesArea = $$v
                  },
                  expression: "outdoorCommonSpacesArea"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("theme-numeric", {
                attrs: {
                  "valid-scope": "modal-form",
                  name: "outdoor[common_space_addresses]",
                  label:
                    "" +
                    (_vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.common_outdoor_space_addresses),
                  precision: 0
                },
                on: { input: _vm.countOutdoorPoints },
                model: {
                  value: _vm.outdoorCommonSpacesAddresses,
                  callback: function($$v) {
                    _vm.outdoorCommonSpacesAddresses = $$v
                  },
                  expression: "outdoorCommonSpacesAddresses"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "outdoor[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_outdoor,
                isReadonly: true
              },
              model: {
                value: _vm.outdoor.total,
                callback: function($$v) {
                  _vm.$set(_vm.outdoor, "total", $$v)
                },
                expression: "outdoor.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.vop
            ) +
            "\n      (" +
            _vm._s(
              _vm.locales &&
                _vm.locales.common &&
                _vm.locales.common.minimum + " € " + _vm.independantMinVopPrice
            ) +
            ")\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-4 mb-10" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[price]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.enter_vop
              },
              on: { input: _vm.countVopPoints },
              model: {
                value: _vm.vop.price.value,
                callback: function($$v) {
                  _vm.$set(_vm.vop.price, "value", $$v)
                },
                expression: "vop.price.value"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("input", {
            attrs: {
              type: "hidden",
              name: "vop[newly_built_renovated_house]",
              value: "0"
            }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "newly_built_renovated_house",
              label: "",
              "is-single-checkbox": true,
              name: "vop[newly_built_renovated_house]",
              options: {
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.newly_built_renovated_house
              }
            },
            on: { input: _vm.countVopPoints },
            model: {
              value: _vm.vop.newly_built_renovated_house.value,
              callback: function($$v) {
                _vm.$set(_vm.vop.newly_built_renovated_house, "value", $$v)
              },
              expression: "vop.newly_built_renovated_house.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.vop.newly_built_renovated_house.value
        ? _c(
            "div",
            { staticClass: "mb-10" },
            [
              _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.locales &&
                        _vm.locales.properties &&
                        _vm.locales.properties.delivery_in
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  name: "vop[delivery]",
                  options: {
                    2018: "2018",
                    2019: "2019",
                    2020: "2020",
                    2021: "2021",
                    2022: "2022"
                  }
                },
                on: { input: _vm.countVopPoints },
                model: {
                  value: _vm.vop.delivery.value,
                  callback: function($$v) {
                    _vm.$set(_vm.vop.delivery, "value", $$v)
                  },
                  expression: "vop.delivery.value"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vop.delivery.value > 2017
        ? _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-4 mb-10" }, [
            _c(
              "div",
              [
                _c("theme-autocomplete-custom", {
                  attrs: {
                    options: _vm.muncipalities,
                    initial: _vm.vop.location.value,
                    name: "vop[location]",
                    label:
                      _vm.locales &&
                      _vm.locales.properties &&
                      _vm.locales.properties.muncipality
                  },
                  on: { input: _vm.countVopPoints },
                  model: {
                    value: _vm.vop.location.value,
                    callback: function($$v) {
                      _vm.$set(_vm.vop.location, "value", $$v)
                    },
                    expression: "vop.location.value"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-2 lg:grid-cols-3 mb-10" }, [
        _c("div", [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.vop_absolute
                ) +
                "\n        "
            )
          ]),
          _vm._v("\n        " + _vm._s(_vm.vop.absolute) + "\n      ")
        ]),
        _vm._v(" "),
        _c("div", [
          _c("h3", { staticClass: "calculate-price__form-subtitle" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.locales &&
                    _vm.locales.properties &&
                    _vm.locales.properties.vop_surface_proportion
                ) +
                "\n        "
            )
          ]),
          _vm._v("\n        " + _vm._s(_vm.vop.surface_proportion) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "vop[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_vop,
                isReadonly: true
              },
              model: {
                value: _vm.vop.total,
                callback: function($$v) {
                  _vm.$set(_vm.vop, "total", $$v)
                },
                expression: "vop.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-section" }, [
      _c("h2", { staticClass: "calculate-price__form-title" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.locales &&
                _vm.locales.properties &&
                _vm.locales.properties.care_home
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-10" },
        [
          _c("input", {
            attrs: { type: "hidden", name: "care_home[value]", value: "0" }
          }),
          _vm._v(" "),
          _c("theme-checkboxes", {
            attrs: {
              id: "care_home",
              label: "",
              "is-single-checkbox": true,
              name: "care_home[value]",
              options: {
                "1":
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.care_home
              }
            },
            on: { input: _vm.countCareHomePoints },
            model: {
              value: _vm.careHome.value,
              callback: function($$v) {
                _vm.$set(_vm.careHome, "value", $$v)
              },
              expression: "careHome.value"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "grid grid-cols-1 lg:grid-cols-3" }, [
        _c(
          "div",
          [
            _c("theme-numeric", {
              attrs: {
                "valid-scope": "modal-form",
                name: "care_home[total]",
                label:
                  _vm.locales &&
                  _vm.locales.properties &&
                  _vm.locales.properties.total_care_home,
                isReadonly: true
              },
              model: {
                value: _vm.careHome.total,
                callback: function($$v) {
                  _vm.$set(_vm.careHome, "total", $$v)
                },
                expression: "careHome.total"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "calculate-price__form-bottom" }, [
      _c(
        "div",
        {
          staticClass:
            "default-content grid grid-cols-1 lg:grid-cols-12 items-center gap-1 lg:gap-5"
        },
        [
          _c("div", { staticClass: "col-span-2 hidden lg:block" }, [
            _c("h3", { staticClass: "calculate-price__form-bottom-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    this.locales &&
                      this.locales.common &&
                      this.locales.common.total
                  ) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lg:col-span-7" }, [
            _c("div", { staticClass: "grid grid-cols-2 items-center gap-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.locales &&
                              _vm.locales.properties &&
                              _vm.locales.properties.total_points
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.totalPoints || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: {
                          "valid-scope": "modal-form",
                          name: "total",
                          label: "",
                          isReadonly: true
                        },
                        model: {
                          value: _vm.totalPoints,
                          callback: function($$v) {
                            _vm.totalPoints = $$v
                          },
                          expression: "totalPoints"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid lg:grid-cols-2 items-center gap-1 lg:gap-5 lg:pr-6"
                },
                [
                  _c(
                    "div",
                    { staticClass: "calculate-price__form-bottom-label" },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.locales &&
                              _vm.locales.properties &&
                              _vm.locales.properties.max_basic_rent_price
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "lg:hidden" }, [
                    _vm._v(_vm._s(_vm.price || "0"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "hidden lg:block" },
                    [
                      _c("theme-numeric", {
                        attrs: {
                          "valid-scope": "modal-form",
                          name: "price",
                          label: "",
                          isReadonly: true
                        },
                        model: {
                          value: _vm.price,
                          callback: function($$v) {
                            _vm.price = $$v
                          },
                          expression: "price"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "lg:col-span-3 grid grid-cols-2 items-center gap-5"
            },
            [
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.download_pdf
                      ) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "theme-btn theme-btn--theme",
                  attrs: { type: "submit", name: "submit", value: "save" }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.locales &&
                          _vm.locales.common &&
                          _vm.locales.common.save
                      ) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dc4b8de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dc4b8de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/IndependantFormNew.vue
// module id = 792
// module chunks = 1